import React, { Component, Fragment } from "react";
import { List, Grid } from '@material-ui/core';
import { LinkItem } from './LinkItem';
import { FilterTabs } from './containers/FilterTabs';
import Pane from './containers/Pane';
import { LoadingProgress } from './containers/LoadingProgress';

class Links extends Component {

  constructor() {
    super()
    this.state = {
      selectedFilter: 0,
    }
  }

  componentDidMount() {
    this.props.onRefreshData();
  }

  onExternalLink = (e, url) => {
    e.preventDefault();
    window.open(url);
  }

  getLinksByFilter() {
    return Object.entries(
      this.props.links.reduce((links, link) => {
        const filtersArray = link.filters.split("|");
        for(let i = 0; i < filtersArray.length; i++) {
          links[filtersArray[i]] = links[filtersArray[i]]
          ? [...links[filtersArray[i]], link]
          : [link]
        }

        return links;
      }, {})
    );
  }

  handleFilterSelected = selectedFilter => {
    this.setState({
      selectedFilter
    });
  };

  render() {
    const {
      filters,
      links,
      moduleType,
      translations,
      appLanguage
    } = this.props;
    const { selectedFilter, } = this.state;
    const pageTitle = moduleType === 'links'
      ? translations.t_TITLE_LINKS[appLanguage]
      : translations.t_MODULE_LINKLIST_TITLE[appLanguage];
    const LinksItems = selectedFilter ? this.getLinksByFilter().map(([filter, links]) => {
      return selectedFilter === filter
      ? links.map((item) => {
        return (
          <LinkItem
            key={item.id ? item.id : 0}
            item={item}
            appLanguage={appLanguage}
            onClick={this.onExternalLink}
          />
        )
      })
      : null
    }) : links.map((item) => {
      return (
        <LinkItem
          key={item.id ? item.id : 0}
          item={item}
          appLanguage={appLanguage}
          onClick={this.onExternalLink}
        />
      )
    });
    return (
      <Fragment>
        <Grid container justify="center">
          <Grid item xs sm={9} lg={8} xl={7}>
            <Pane
              header={pageTitle}
              filterTabs={
                filters.length > 0 ?
                <FilterTabs
                  filters={filters}
                  selectedFilter={selectedFilter}
                  onFilterSelect={this.handleFilterSelected}
                />
                : null
              }
            >
              <LoadingProgress data={links}>
                <List>
                  {LinksItems}
                </List>
              </LoadingProgress>
            </Pane>
          </Grid>
        </Grid>
      </Fragment>
    );
  }

}

export default Links;


// WEBPACK FOOTER //
// ./src/components/Links.js